module.exports = __webpack_public_path__ + "media/images/attachmentSvg-29ce0501.svg";